import branch from "recompose/branch";
import BaseErrorComponent from "./PageError";

const withErrorFallback = ({
  hasError,
  ErrorComponent = BaseErrorComponent,
}) => {
  return branch(
    hasError,
    () => ErrorComponent,
    (BaseComponent) => BaseComponent
  );
};

export default withErrorFallback;
